import React from "react";
import "./FunActivities.css";
import API_CONFIG from "../config/api";

const FunActivities = ({ mainTitle, subTitle, activities }) => {
  return (
    <div className="activities-container">
      <h1 className="main-title">
        {mainTitle} <br />
        <span>{subTitle}</span>
      </h1>
      <div className="activities-grid">
        {activities.map((activity, index) => (
          <div className="activity-card" key={index}>
            <img
              src={`${API_CONFIG.IMAGES_URL}/${activity.image}`}
              alt={activity.title}
              className="activity-image"
            />
            <h3 className="activity-title">{activity.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunActivities;
